module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step1a_Image14j.20b7645c.jpg";